import consumerApi from "@/api/services/consumer-api";
import publicConfig from "@/config/public";
import { MenuItemV2 } from "@/custom-types/MenuItemV2";
import logError from "@/utils/logError";

export enum SHOP_CORE_SORT_OPTIONS {
  DELIVERY_FEE = "dispensary.delivery_service_area_ranges.max_fee",
  DELIVERY_MINIMUM = "dispensary.delivery_service_area_ranges.max_order_minimum",
  DELIVERY_TIME = "dispensary.delivery_service_area_ranges.max_delivery_duration_maximum",
  PICKUP_DISTANCE = "dispensary.location",
  THC = "thc_content",
  PRICE = "sort_price",
}

export type SortDirection = "asc" | "desc";

export interface Params {
  q?: string;
  take?: number;
  skip?: number;
  filters?: { [key: string]: string | boolean };
  sort?: string;
  sortDirection?: SortDirection;
  boost?: string;
  boost_options?: { [key: string]: string };
}

// * Custom types for this response
export type AvailableFilter = {
  label: string;
  name: string;
  values: { value: string; count: number }[];
};

export type Metadata = {
  availableFilters: AvailableFilter[];
  availableSorts: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  relevanceOrder?: any;
  supportedFilters?: string[];
  totalCount: number;
};

export interface ShopCoreMenuItemsResponse {
  data: MenuItemV2[];
  metadata: Metadata;
}

export interface ShopCoreMenuItemsApiResponse {
  data: ShopCoreMenuItemsResponse;
}

const { timeout } = publicConfig;

const searchShopCoreMenuItems = async (
  lat: number,
  lon: number,
  {
    boost,
    boost_options,
    q,
    take,
    skip,
    sort,
    sortDirection = "asc",
    filters = {},
  }: Params,
): Promise<ShopCoreMenuItemsApiResponse> => {
  try {
    return await consumerApi.get(`/api/menu_items/v2/shop`, {
      params: {
        boost,
        ...(boost_options &&
          boost_options?.strain_name && {
            "boost_options[strain_name]": boost_options.strain_name,
          }),
        lat,
        lon,
        q,
        skip,
        ...(sort && sort.length > 0
          ? { [`sort[0][${sort}]`]: sortDirection }
          : {}),
        take,
        ...filters,
        decorate_with_user_fulfillment: true,
        enable_new_filters: true,
      },
      timeout: timeout.deliverySearch,
    });
  } catch (e) {
    logError(e.message, {
      functionName: "searchDeliveryMenuItems",
      service: "consumer",
      statusCode: e.statusCode,
    });

    return {
      data: {
        data: [],
        metadata: {
          availableFilters: [],
          availableSorts: [],
          supportedFilters: [],
          totalCount: 0,
        },
      },
    };
  }
};

export default searchShopCoreMenuItems;
